/* =============================================================================
 * M.M.LaFleur — keep the sticky Add to Bag bar above the support-chat launcher.
 *
 * Loaded on the PDP only, from mm_product_media.liquid.
 *
 * WHAT LIVE DOES, AND WHAT THIS NOW MATCHES
 * -----------------------------------------
 * The live theme does not move the chat launcher. It lets the bar paint OVER
 * it, so the bubble slides behind the bar as you scroll. An earlier version of
 * this file lifted the launcher upward instead — which cleared the button, but
 * left the two stacked vertically rather than layered, and did not look like
 * live. This does what live does.
 *
 * WHY z-index ALONE IS NOT ENOUGH
 * -------------------------------
 * z-index caps at 2147483647, and chat vendors habitually set their launcher at
 * or very near that ceiling from an inline style after load. When two elements
 * tie on z-index the one LATER IN THE DOM paints on top — and the widget is
 * injected asynchronously, seconds after the page, which puts it after the bar
 * every time. At the ceiling the bar cannot win on number alone.
 *
 * So the bar is moved to the end of <body> once a launcher is detected after
 * it. Same z-index, later in document order, so the tie resolves the other way.
 * appendChild MOVES the node rather than copying it — listeners, observers and
 * the element's own state all survive, which is why this is safe to do to a bar
 * that is already wired up.
 *
 * WHY THE LAUNCHER IS FOUND BY SHAPE
 * ----------------------------------
 * This store has more than one support app installed, and the widget is
 * injected by a script Liquid cannot read, so a list of vendor container ids is
 * a guess. Instead this looks for what a launcher IS: a fixed-position element,
 * pinned near the bottom of the viewport, small, and not ours. That keeps
 * working when a vendor renames a container or the store swaps providers.
 *
 * The open chat PANEL is deliberately excluded by size. A dialog covering the
 * bar is correct behaviour — it is a window the shopper opened, not a control
 * competing for the corner.
 * ========================================================================== */

(function () {
  "use strict";

  /* How close to the bottom edge an element has to sit to count as a launcher,
     and how large it is allowed to be. */
  var CORNER_PX = 220;
  var MAX_SIDE_PX = 220;

  var TOP_LAYER = "2147483647";

  function bar() {
    return document.querySelector(".mm-sticky-atc");
  }

  function isOurs(node) {
    return !!(
      node.closest(".mm-scope") ||
      node.closest("[data-mm-header]") ||
      node.closest("[data-mm-drawer]") ||
      node.classList.contains("mm-sticky-atc") ||
      node.classList.contains("mm-quiz-fab")
    );
  }

  /* Two levels deep only. Every launcher in the wild is either a direct child
     of <body> or one wrapper inside it, and walking the whole tree on every
     mutation would be a real cost for no gain. */
  function candidates() {
    var out = [];

    Array.prototype.slice.call(document.body.children).forEach(function (node) {
      if (!(node instanceof HTMLElement)) return;
      out.push(node);
      Array.prototype.slice.call(node.children).forEach(function (child) {
        if (child instanceof HTMLElement) out.push(child);
      });
    });

    return out;
  }

  function isLauncher(node) {
    if (isOurs(node)) return false;
    if (node.hidden) return false;

    var style = window.getComputedStyle(node);
    if (style.position !== "fixed") return false;
    if (style.display === "none" || style.visibility === "hidden") return false;

    var rect = node.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;
    if (rect.width > MAX_SIDE_PX || rect.height > MAX_SIDE_PX) return false;

    var vh = window.innerHeight;
    return rect.bottom > vh - CORNER_PX && rect.top < vh;
  }

  function sync() {
    var b = bar();
    if (!b) return;

    /* Claim the ceiling. Ties are then broken by document order below. */
    b.style.setProperty("z-index", TOP_LAYER, "important");

    /* Already the last thing in the body — nothing can be painting over it,
       and re-appending would churn for no reason. This check is also what stops
       the MutationObserver below from looping on our own move. */
    if (b.parentNode === document.body && document.body.lastElementChild === b) return;

    var outranked = candidates().some(function (node) {
      if (!isLauncher(node)) return false;
      /* DOCUMENT_POSITION_FOLLOWING: the node comes after the bar, so on an
         equal z-index it wins. That is the case worth fixing. */
      return !!(b.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_FOLLOWING);
    });

    if (outranked) document.body.appendChild(b);
  }

  function start() {
    sync();

    /* Chat widgets load asynchronously and often several seconds after the
       page, so a single pass at DOMContentLoaded finds nothing at all. These
       retries are cheap and stop on their own. */
    [400, 1200, 3000, 6000].forEach(function (ms) {
      window.setTimeout(sync, ms);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  var pending = null;
  function debounced() {
    if (pending) window.clearTimeout(pending);
    pending = window.setTimeout(sync, 200);
  }

  /* A widget appearing, or Barba swapping the page. Direct children only — a
     subtree observer would fire on every message the chat widget renders. */
  new MutationObserver(debounced).observe(document.body, { childList: true, subtree: false });

  window.addEventListener("resize", debounced, { passive: true });
  window.addEventListener("orientationchange", debounced, { passive: true });
}());
